import { render, staticRenderFns } from "./ViewForm.vue?vue&type=template&id=113a7004"
import script from "./ViewForm.vue?vue&type=script&lang=js"
export * from "./ViewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('113a7004')) {
      api.createRecord('113a7004', component.options)
    } else {
      api.reload('113a7004', component.options)
    }
    module.hot.accept("./ViewForm.vue?vue&type=template&id=113a7004", function () {
      api.rerender('113a7004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/csg/sku/components/ViewForm.vue"
export default component.exports